import { FormEvent, useState } from 'react';
import useTableOrder from 'hooks/tableOrder';
import { PaymentMethod } from 'types/paymentMethod';
import { api } from 'services/api';
import { Paginated } from 'types/paginated';
import { toast } from 'react-toastify';

export type PaymentMethodQueryParams = {
  name: string;
};

export function useFetchPaymentMethods() {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [rows, setRows] = useState<number>(96);
  const [total, setTotal] = useState<number>(0);
  const [, sort] = useTableOrder();
  const [filter, setFilter] = useState<PaymentMethodQueryParams>({
    name: '',
  });

  function fetchData(nextPage = page, nextRows = rows, nextFilter = filter) {
    setLoading(true);

    api
      .get<Paginated<PaymentMethod[]>>('/payment-methods', {
        params: {
          ...nextFilter,
          page: nextPage + 1,
          rows: nextRows,
          active: 1,
        },
      })
      .then(response => {
        setTotal(response.data.total);
        setPaymentMethods(response.data.items);
      })
      .catch(() => {
        setPaymentMethods([]);
        toast.error('Erro ao buscar formas de recebimento');
      })
      .finally(() => setLoading(false));
  }

  function handleSearch(e?: FormEvent<HTMLFormElement>) {
    e?.preventDefault();
    setPage(0);
    fetchData(0, rows, filter);
  }

  function handleChangePage(nextPage: number) {
    setPage(nextPage);
    fetchData(nextPage, rows, filter);
  }

  function handleChangeRows(nextRows: number) {
    setRows(nextRows);
    setPage(0);
    fetchData(0, nextRows, filter);
  }

  function handleSort(index: string) {
    const p = sort(index, paymentMethods);
    setPaymentMethods(p);
  }

  function handleChange<K extends keyof PaymentMethodQueryParams>(index: K, value: PaymentMethodQueryParams[K]) {
    setFilter(state => ({
      ...state,
      [index]: value,
    }));
  }

  return {
    paymentMethods,
    loading,
    handleSort,
    filter,
    handleChange,
    setPage: handleChangePage,
    setRows: handleChangeRows,
    handleSearch,
    page,
    rows,
    total,
  };
}
